import React, { useState, useCallback, useRef } from "react";

import { PlaceOrderForm } from "../shared/PlaceOrderForm";
import { CaptchaService, useTranslations, useErrorContext } from "tds_shared_ui";
import { LocksmithIDLoginModal } from "../UI";
import { usePlaceOrder } from "../../hooks/usePlaceOrder";

export function Confirmation({
  onPlaceOrder,
  onSubmit,
  checkoutSummary,
  formValues,
  onChange,
  onCancel,
  onBack,
  readOnly,
  className,
  paymentContainerId,
}) {
  const captchaRef = useRef(null);
  const [showLocksmithFields, setShowLocksmithFields] = useState(false);

  const { translate } = useTranslations(["common", "keycode"]);
  const { displayAlert } = useErrorContext();

  const {
    placeOrder,
    loading,
    paymentBlocked,
    onPaymentSuccess,
    onPaymentError,
    onValidationChange,
    onSubmitAvailable,
  } = usePlaceOrder({
    onPlaceOrder,
    onSubmit,
    checkoutSummary,
    formValues,
  });

  const handlePlaceOrder = useCallback(() => {
    const captchaData = CaptchaService.getCaptchaData(captchaRef);

    if (!captchaData.cText) {
      displayAlert(translate("ERROR_CAPTCHA_MUST_BE_COMPLETED"), "error");
      return;
    }

    setShowLocksmithFields(true);
  }, [translate, displayAlert]);

  const handleCancelModal = useCallback(() => {
    setShowLocksmithFields(false);
  }, []);

  const handleLocksmithSubmit = useCallback(
    async (passcode) => {
      setShowLocksmithFields(false);

      const captchaData = CaptchaService.getCaptchaData(captchaRef);

      await placeOrder({
        passcode,
        ...captchaData,
      });

      return Promise.resolve();
    },
    [placeOrder]
  );

  return (
    <div>
      <PlaceOrderForm
        variant="keycodes"
        onSubmit={handlePlaceOrder}
        className={className}
        checkoutSummary={checkoutSummary}
        formValues={formValues}
        onChange={onChange}
        readOnly={readOnly}
        loading={loading}
        paymentBlocked={paymentBlocked}
        onPaymentSuccess={onPaymentSuccess}
        onPaymentError={onPaymentError}
        onValidationChange={onValidationChange}
        onSubmitAvailable={onSubmitAvailable}
        onCancel={onCancel}
        onBack={onBack}
        captchaRef={captchaRef}
        paymentContainerId={paymentContainerId}
      />

      <LocksmithIDLoginModal
        submitButtonText={translate("BUTTON_PLACE_ORDER")}
        onSubmit={handleLocksmithSubmit}
        open={showLocksmithFields}
        onCancel={handleCancelModal}
      />
    </div>
  );
}
